import { Coffee, type LucideIcon, Sun, Sunset, UtensilsCrossed } from 'lucide-react'

import type { MealType } from '@/api/types/nutrition'

export const MEAL_TYPE_ORDER: readonly MealType[] = ['breakfast', 'lunch', 'dinner', 'snack']

export const MEAL_TYPE_LABELS: Record<MealType, string> = {
  breakfast: '朝食',
  lunch: '昼食',
  dinner: '夕食',
  snack: '間食',
}

export const MEAL_TYPE_ICONS: Record<MealType, LucideIcon> = {
  breakfast: Sun,
  lunch: UtensilsCrossed,
  dinner: Sunset,
  snack: Coffee,
}

export function isMealType(value: string): value is MealType {
  return (MEAL_TYPE_ORDER as readonly string[]).includes(value)
}
